export { Body1, Body2 } from '@sberdevices/plasma-core';
